import React from 'react';
import styles from './Home.module.css';
import LogoHero from './home-sub-sections/LogoHero';
import HomeIntro from './home-sub-sections/HomeIntro';
import WhyChooseUs from './home-sub-sections/WhyChooseUs';
import ProudlyLocal from './home-sub-sections/ProudlyLocal';
const Home: React.FC = () => {
  return (
    <div className={styles.homeContainer}>

      {/* Logo Hero section with dark background */}
      <LogoHero />

      {/* Home Intro section with company story */}
      <HomeIntro />

      {/* Why Choose Us component */}
      <WhyChooseUs />

      {/* Proudly Local section */}
      <ProudlyLocal />
    </div>
  );
};

export default Home;